<template>
  <div>
    <ul>
      <li
        :class="shouldShowListDivider(idx) ? 'box' : 'box no-line'"
        v-for="(product, idx) in list"
        :key="idx"
        @click="emitSplitClick(idx)"
      >
        <!-- <span v-if="mode === 'stock' || mode === 'edit'">
          <ListIcon v-model="product.available" />
        </span> -->

        <div
          :class="getSplitButtonClass(product.splitIndex + 1)"
          v-if="splitting"
        >
          {{ product.splitIndex + 1 }}
        </div>
        <!-- <img :src="`/icons/split-circle-${product.splitIndex+1}.svg`" class="split" v-if="splitting" /> -->

        <div class="w-100">
          <small :class="mode === 'view' ? 'd-block no-space' : 'd-block'">
            {{ product.category }}
          </small>

          <span v-if="mode === 'view'">
            <!-- Show the icon only if product is not avaliable-->
            <ListIcon
              v-model="product.available"
              readonly
              v-if="!product.available"
            />
          </span>

          <div class="dish-item-box">
            <b class="product-name">
              {{ product.name }}

              <span
                class="color-black"
                v-if="product.weight_flag == 2 && product.total_weight"
              >
                ({{ (product.total_weight).toFixed(2) }} {{ $t("units." + product.unit) }})
              </span>
            </b>

            <span class="qnt" v-if="mode !== 'edit' && !splitting">
              {{ getItemQuantity(product) }}
            </span>
            <span
              v-if="mode !== 'edit' || mode !== 'view'"
              class="price float-right"
              >{{ getProductPrice(product) }}{{ currency.symbol }}</span
            >
          </div>
 <span
            class="product-variant color-black"
            v-if="product.variant && product.variant != '*'"
            >({{ product.variant }})</span
          >
          <div class="modificators" v-if="product.modificators">
            <ul>
              <div class="dish-column" v-for="mod in product.modificators">
              <li>
                + {{ mod.name }}
              </li>
               <span class="float-right">{{ mod.price }}₴</span>
              </div>
            </ul>
          </div>

          <div class="price-hinter" v-if="product.modificators && product.modificators.length">
            <span>{{ $t('card.total') }}</span>
            <span>{{ getTotalItemPrice(product) }}{{ currency.symbol}}</span>
          </div>
         

          <div
            class="edit-actions"
            v-if="
              mode === 'edit' && product.available && product.weight_flag != 2
            "
          >
            <img
              :src="
                product.quantity <= 1
                  ? '/icons/del-red.svg'
                  : '/icons/btn-minus.svg'
              "
              :class="product.quantity <= 1 ? 'btn-minus sm' : 'btn-minus'"
              @click="changeQuantity(idx, -1)"
              :disabled="list.length == 1 && product.quantity == 1"
            />

            <span v-if="product.weight_flag == 0">{{ product.quantity }}x</span>
            <span v-if="product.weight_flag == 1">
              {{ (product.quantity * product.weight).toFixed(2) }}
              {{ $t("units." + product.unit) }}
            </span>

            <img
              src="/icons/btn-plus.svg"
              class="btn-plus"
              @click="changeQuantity(idx, 1)"
            />
          </div>

          <div
            class="edit-actions weight-actions"
            v-if="
              mode === 'edit' && product.available && product.weight_flag == 2
            "
          >
            <input
              type="number"
              class="weight-input"
              v-model.number="list[idx].total_weight"
              :placeholder="$t('item_list.weight_input')"
            />
          </div>

          <!-- <QueueButton
            class="w-100 pt-15"
            variant="cancel"
            @click="changeQuantity(idx, -1000)"
            v-if="mode == 'edit' && product.weight_flag == 1"
          >
            Видалити страву
          </QueueButton> -->
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import ListIcon from "@/components/item/ListIcon.vue";

import QueueButton from "@/components/QueueButton.vue";

export default {
  props: {
    mode: {
      type: String,
      default: "view",
    },
    list: Array,
    splitting: {
      type: Boolean,
      default: false,
    },
    new_preorder: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      colors: ["red", "green", "yellow"],
    };
  },
  methods: {
    toggleAvailability(idx) {
      this.$emit("toggleAvailability", idx);
    },
    changeQuantity(idx, delta) {
      this.$emit("changeQuantity", idx, delta);
    },
    emitSplitClick(idx) {
      if (!this.splitting) return;
      this.$emit("splitClick", idx);
    },
    getSplitButtonClass(index) {
      return ["split-btn", `split-btn-index-${index}`];
    },
    getTotalItemPrice(item) {
      const base_price = item.price;
      // const variants_price = (item.variants || []).reduce((acc,v) => {
      //   return acc + v.price;
      // }, 0);
      const mods_price = (item.modificators || []).reduce((acc,m) => {
        return acc + m.price;
      }, 0);

      return Math.round(base_price + mods_price);
    },  
    getItemQuantity(item) {
      if (item.weight_flag == 1) {
        let item_weight = Math.round(item.quantity * item.weight * 100) / 100;
        let item_unit = item.unit;

        if (item_weight >= 1000) {
          item_weight = Math.round((item_weight / 1000) * 100) / 100;
          item_unit = item.unit == "g" ? "kg" : "l";
        }

        return `${item_weight}${this.$t("units." + item_unit)}`;
      } else {
        return `x${item.quantity}`;
      }
    },
    shouldShowListDivider(index) {
      return true;
      // if (this.mode != 'edit') return true;

      // if (this.list.length-1 != index) return true;

      // return this.new_preorder;
    },
    getProductPrice(product) {
      if (product.weight_flag == 0) {
        return Math.round(product.price);
      } else {
        //fixed weight - fixed price
        //total weight - total price
        return Math.round(product.price * product.quantity);
        // return (product.total_weight * product.price) / product.weight;
      }
    },
  },
  computed: {
    currency() {
      return this.$store.state.currency;
    },
  },
  components: {
    ListIcon,
    QueueButton,
  },
};
</script>

<style scoped>
small {
  font-size: 3.8vw;
  line-height: normal;
  color: #a4a3a1;
  font-weight: 400;
}

span img {
  margin: 1.9vh 5.4vw 0 0;
}

small.no-space {
  padding: 0;
}

ul {
  padding-left: 0;
  margin-bottom: 0;
}

.dish-item-box {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 0.6vh;
}

.dish-column {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

li.box {
  display: flex;
  padding: 1.9vh;
  align-items: flex-start;
  border-bottom: 1px solid #a4a3a1;
}

li.box.no-line:last-child {
  border-bottom: 0 !important;
}

.product-wrapper {
  display: flex;
  justify-content: space-between;
}

.b-bottom {
  border-bottom: none !important;
}
li.box img {
  height: 2vh;
  margin: -1vh 0.5vh 0 0;
  width: auto;
  z-index: 1;
}

hr {
  margin: 10px -20px 0 -20px;
  border-top: 1px solid #bfbfbf;
}

ul {
  list-style-type: none;
}

.svg-inline--fa.fa-w-14 {
  width: 0.875em;
  height: 15px;
}

.btn-plus,
.btn-minus {
  width: auto !important;
  height: 4vh !important;
}

.btn-minus.sm {
  height: 2.8vh;
  margin-left: 1vh;
}

.edit-actions {
  display: flex;
  align-items: center;
  padding-top: 3.7vh;
  justify-content: space-between;
  width: 100%;
}

.edit-actions span {
  font-size: 24px;
}

b.product-name {
  font-weight: 400;
  font-size: 4.8vw;
  line-height: normal;
  width: 63%;
  display: inline-block;
}

.product-variant {
  display: block;
  font-size: 4vw;
  width: 63%;
  padding-top: 0.6vh;
  line-height: normal;
}

.product-name span {
  font-size: 4.8vw;
  width: max-content;
  display: block;
  font-weight: 400;
}

.content ul {
  list-style-type: none;
  padding: 0;
  margin-bottom: 0;
}

.price {
  font-weight: 500;
  position: relative;
  z-index: 1;
  max-width: 18vw;
  line-height: normal;
  text-align: right;
  padding-left: 1.2vh;
  font-size: 5.4vw;
  color: #908F8D;
}

.modificators li {
  padding: 0.6vh 0 0 0;
  font-size: 1.9vh;
  width: 63%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #464646;
}

.modificators span {
  padding-left: 1.2vh;
  position: relative;
  color: #908F8D;
  line-height: normal;
}

b {
  font-size: 18px;
}

span.qnt {
  font-size: 4vw;
  z-index: 1;
  line-height: normal;
  color: #908F8D;
  text-align: right;
   padding: 0;
  float: right;
  display: flex;
}

.split-btn {
  color: black;
  background-color: white;
  position: absolute;
  font-size: 20px;
  right: 0;
  margin-top: -2.4vh;
  text-align: center;
  display: inline-block;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  border-radius: 0px 0px 0px 5px;
  padding: 0.3vh 3.3vw;
  width: 4.2vh;
  height: 4.2vh;
  line-height: 1.4;

  display: flex;
  justify-content: center;
  align-items: center;
}

.split-btn-index-1 {
  background: #ffd2a8;
  color: #1d1d1b;
}

.split-btn-index-2 {
  background: #416293;
  color: #ededed;
}

.split-btn-index-3 {
  background: #129b81;
  color: #ededed;
}

.split-btn-index-4 {
  background: #e2223b;
  color: #ededed;
}

.split-btn-index-5 {
  background: #1d1d1b;
  color: #ededed;
}

.weight-actions {
  padding-top: 2.5vh !important;
}

.weight-input {
  text-align-last: center;
  text-align: -webkit-center;
  background: white;
  border: 1px solid #a4a3a1;
  font-size: 3vh;
  font-weight: bold;
  padding: 0.2vh 0 0.4vh;
  color: #5a5a5a;
  border-radius: 5vh;
  width: 100%;
  outline: none;
}

.weight-input:focus {
  outline: none;
}

.price-hinter {
  display: flex;
  justify-content: space-between;
  font-size: 2vh;
  margin-top: 1vh;
}

@media (min-width: 768px) {
  .edit-actions {
    padding: 2vw 3.993vw 0;
  }
  .edit-actions img.btn-plus,
  .edit-actions img.btn-minus {
    width: 2vw;
    height: 2vw;
    margin: 0;
  }
  img.btn-minus.sm {
    width: 1.389vw;
    height: 1.389vw;
  }
  .edit-actions span {
    font-size: 1.667vw;
    line-height: 1.944vw;
  }
  li.box {
    padding: 1.458vw 1.389vw;
    margin: 0;
  }
  span.price {
    font-size: 2.083vw;
    line-height: 1vw;
    min-width: 0;
    margin: 0;
    margin-left: 0.833vw;
  }
  small.d-block {
    font-size: 0.972vw;
    line-height: 1.111vw;
    margin-bottom: 0.694vw;
  }
  b.product-name {
    font-size: 1.389vw;
    line-height: 1.597vw;
    width: 9.306vw;
  }
  span.qnt {
    font-size: 1.25vw;
    margin-top: 0;
    line-height: 1.5vw;
    width: 2.292vw;
  }
  span.color-black {
    font-size: 0.972vw;
    line-height: 1.111vw;
  }
  .modificators ul li {
    font-size: 0.972vw;
    line-height: 1.111vw;
    margin-left: 0;
  }
  div.edit-actions {
    display: flex;
    align-items: center;
    padding-top: 3.7vh;
    justify-content: space-between;
    width: 100%;
  }
}
</style>
